import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="space-y-4 py-20 text-center">
      <h1 className="text-3xl font-bold text-slate-100">Page not found</h1>
      <p className="text-slate-400">That link doesn’t lead anywhere.</p>
      <Link
        to="/"
        className="inline-block rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-brand-400"
      >
        Back to home
      </Link>
    </div>
  );
}
